let update_JOPending = function(tagId) {
    let i = {
        typeUser: this.typez,
        tag_id: tagId
    };
    this.$store.dispatch("ModApps/jobs/update_JOPending", i);
};
export default update_JOPending;
